import React, { useEffect, useState } from 'react';
import { Hero } from './components/Hero';
import { CredibilityBadges } from './components/CredibilityBadges';
import { ProblemSection } from './components/ProblemSection';
import { ComparisonTable } from './components/ComparisonTable';
import { ScienceSection } from './components/ScienceSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { RiskFactorsSection } from './components/RiskFactorsSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { ExitPopup } from './components/ExitPopup';
import { FloatingSocialProof } from './components/FloatingSocialProof';
import { ComparisonWidget } from './components/ComparisonWidget';
import { ExpertSection } from './components/ExpertSection';
export function App() {
  const [showExitPopup, setShowExitPopup] = useState(false);
  const [showComparisonWidget, setShowComparisonWidget] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show comparison widget after scrolling past hero
      if (window.scrollY > 600 && !showComparisonWidget) {
        setShowComparisonWidget(true);
      }
    };
    const handleMouseLeave = e => {
      // Only trigger if mouse leaves at the top of the page
      if (e.clientY <= 0 && !showExitPopup && window.scrollY > 300) {
        setShowExitPopup(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [showComparisonWidget, showExitPopup]);
  return <div className="font-sans bg-white text-gray-800" data-id="element-0">
      <main className="w-full" data-id="element-1">
        <Hero data-id="element-2" />
        <CredibilityBadges data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <ComparisonTable data-id="element-5" />
        <ScienceSection data-id="element-6" />
        <ExpertSection data-id="element-7" />
        <BenefitsSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <RiskFactorsSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <CTASection data-id="element-12" />
      </main>
      {showComparisonWidget && <ComparisonWidget data-id="element-13" />}
      {showExitPopup && <ExitPopup onClose={() => setShowExitPopup(false)} data-id="element-14" />}
      <FloatingSocialProof data-id="element-15" />
    </div>;
}